import { Modal, Step, StepLabel, Stepper, TextField } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../AuthContext/AuthContext";
import { loader } from "../../Func_genericas/loader";
import { cores, mensagem_tem_a_certeza_de_apagar_alteracoes, operacao_erro, operacao_sucesso } from "../../Func_genericas/valores_estaticos";
import { post, put } from "../../Services/tokenConfig";
import { func_print } from "../../Func_genericas/func_print";
import { IOperacaoAgricola, IOperacaoTrabalhadorSchema } from "../../Interfaces/atividade/atividade";
import { CustomTextField } from "../../Styles/theme/customThemeprovider";
import { ITrabalhador } from "../../Interfaces/maoobra/maoobra";
import ConfirmDialog from "../../Components/CustomDialog/customdialog";

interface I_aux {
    list: IOperacaoTrabalhadorSchema[],
    flag_open_modal: boolean,
    set_flag_open_modal: React.Dispatch<React.SetStateAction<boolean>>,
    flag_open_modal_ver_mais: boolean,
    set_flag_open_modal_ver_mais: React.Dispatch<React.SetStateAction<boolean>>,
    flag_open_modal_edit: boolean,
    set_flag_open_modal_edit: React.Dispatch<React.SetStateAction<boolean>>,
    flag_open_modal_add: boolean,
    set_flag_open_modal_add: React.Dispatch<React.SetStateAction<boolean>>,
    setMessage: React.Dispatch<React.SetStateAction<string>>,
    setOpenSnackSuccess: React.Dispatch<React.SetStateAction<boolean>>,
    setOpenSnackError: React.Dispatch<React.SetStateAction<boolean>>,
    set_list: React.Dispatch<React.SetStateAction<IOperacaoTrabalhadorSchema[]>>,
    set_obj_new: React.Dispatch<React.SetStateAction<IOperacaoTrabalhadorSchema | undefined>>,
    obj_new: IOperacaoTrabalhadorSchema | undefined,
    obj_atividade: IOperacaoAgricola | undefined,
    lista_de_trabalhadores_aux: ITrabalhador[],
    set_obj_new_atividade: React.Dispatch<React.SetStateAction<IOperacaoAgricola | undefined>>,

}

export const Modaladdtrabalhadors: React.FC<I_aux> = ({
    list,
    flag_open_modal,
    set_flag_open_modal,
    flag_open_modal_ver_mais,
    set_flag_open_modal_ver_mais,
    flag_open_modal_edit,
    set_flag_open_modal_edit,
    flag_open_modal_add,
    set_flag_open_modal_add,
    setMessage,
    setOpenSnackSuccess,
    setOpenSnackError,
    set_list,
    set_obj_new,
    obj_new,
    obj_atividade,
    lista_de_trabalhadores_aux,
    set_obj_new_atividade,

}) => {
    const auth = useContext(AuthContext);

    const [passo_atual, set_passo_atual] = useState<number>(0);

    const steps = [
        'Selecionar Trabalhador',
        'Configurar Dados do Trabalhador',
    ];

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [campo_obrigatorio_categoria, set_campo_obrigatorio_categoria] = useState<boolean>(false);

    const [flag_editado, set_flag_editado] = useState<boolean>(false);
    const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = useState<boolean>(false);

    const [campo_obrigatorio_horas, set_campo_obrigatorio_horas] = useState<boolean>(false);
    const [campo_obrigatorio_custo_hora, set_campo_obrigatorio_custo_hora] = useState<boolean>(false);

    const [hover, setHover] = useState<{ flag: boolean, id_trabalhador: number }>({ flag: false, id_trabalhador: 0 });

    const [obj_trabalhador_selecionado, set_obj_trabalhador_selecionado] = useState<ITrabalhador | undefined>(undefined);

    const handler_add = async () => {

        try {
            setIsLoading(true);
            let res = await post(auth.token.cookie_token, 'api/operacoes/' + obj_atividade?.id_operacao + '/trabalhadores/add', {
                payload: {
                    id_trabalhador: obj_trabalhador_selecionado?.id_trabalhador === undefined ? 0 : obj_trabalhador_selecionado?.id_trabalhador,
                    horas: obj_new?.horas === undefined ? 0 : obj_new?.horas?.toString().replace(',', '.'),
                    custo_hora: obj_new?.custo_hora === undefined ? 0 : obj_new?.custo_hora?.toString().replace(',', '.'),
                    data: obj_new?.data === undefined ? null : obj_new?.data,
                    notas: obj_new?.notas === undefined ? '' : obj_new?.notas,
                }
            });
            if (list === undefined || list.length === 0) {
                set_list([res.data.result])
                set_obj_new_atividade((old: any) => ({
                    ...old,
                    trabalhadores: [res.data.result]
                }))
            } else {
                set_list((old: any) => [...old, res.data.result])
                set_obj_new_atividade((old: any) => ({
                    ...old,
                    trabalhadores: [...(old?.trabalhadores ?? []), res.data.result]
                }))

            }
            setMessage(operacao_sucesso)
            setOpenSnackSuccess(true);
            setIsLoading(false);
            func_reset_all()

        } catch (error) {
            func_print("handler_add", error, true);
            setMessage(operacao_erro)
            setOpenSnackError(true);
            setIsLoading(false);

        }

    }
    const handler_edit = async () => {

        try {
            setIsLoading(true);
            let res = await put(auth.token.cookie_token, 'api/operacoes/trabalhadores/' + obj_new?.id_op_trab, {
                payload: {
                    id_trabalhador: obj_trabalhador_selecionado?.id_trabalhador === undefined ? 0 : obj_trabalhador_selecionado?.id_trabalhador,
                    id_op_trab: obj_new?.id_op_trab === undefined ? 0 : obj_new?.id_op_trab,
                    id_operacao: obj_new?.id_operacao === undefined ? 0 : obj_new?.id_operacao,
                    horas: obj_new?.horas === undefined ? 0 : obj_new?.horas?.toString().replace(',', '.'),
                    custo_hora: obj_new?.custo_hora === undefined ? 0 : obj_new?.custo_hora?.toString().replace(',', '.'),
                    data: obj_new?.data === undefined ? null : obj_new?.data,
                    notas: obj_new?.notas === undefined ? '' : obj_new?.notas,
                }
            });

            let aux_list = list.map((el) => {
                if (el.id_trabalhador === obj_new?.id_trabalhador) {
                    return res.data.result
                } else {
                    return el
                }
            })

            set_list(aux_list)
            set_obj_new_atividade((old: any) => ({
                ...old,
                trabalhadores: aux_list
            }))

            setMessage(operacao_sucesso)
            setOpenSnackSuccess(true);
            setIsLoading(false);
            func_reset_all()

        } catch (error) {
            func_print("handler_edit", error, true);
            setMessage(operacao_erro)
            setOpenSnackError(true);
            setIsLoading(false);
        }


    }

    const onInputChange = (e: any) => {
        const { name, value } = e.target;
        set_flag_editado(true)
        if (name === 'custo_hora') {
            if (!/^(\d+([.,]\d+)?)$/.test(value)) {
                set_campo_obrigatorio_custo_hora(true)
            } else {
                set_campo_obrigatorio_custo_hora(false)
            }
            set_obj_new((prev: any) => ({
                ...prev,
                [name]: value,
            }));
        } else if (name === 'horas') {
            if (!/^(\d+([.,]\d+)?)$/.test(value)) {
                set_campo_obrigatorio_horas(true)
            } else {
                set_campo_obrigatorio_horas(false)
            }

            set_obj_new((prev: any) => ({
                ...prev,
                [name]: value,
            }));
        } else {
            set_obj_new((prev: any) => ({
                ...prev,
                [name]: value,
            }));
        }
    }


    const func_reset_all = () => {
        set_obj_new(undefined);
        set_flag_open_modal_edit(false);
        set_flag_open_modal(false);
        set_campo_obrigatorio_categoria(false);
        set_flag_open_modal(false);
        set_flag_editado(false)
        set_flag_open_modal_ver_mais(false);
        set_flag_open_modal_add(false);

    }
    useEffect(() => {
        (async () => {
            lista_de_trabalhadores_aux.find((el) => {
                if (el.id_trabalhador === obj_new?.id_trabalhador) {
                    set_obj_trabalhador_selecionado(el);
                }
            })

        })();
    }, []);
    const handleCloseDialog = () => {
        func_reset_all()
        set_flag_editado(false)
        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
    };
    return (<Modal
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
        open={flag_open_modal}
    >
        <div className="flex flex-col bg-white w-[70%] max-h-[80%] rounded-xl overflow-hidden">
            <div className="flex items-center justify-between w-full p-4 border-b border-gray-100">
                <h2 className="text-xl font-semibold text-gray-800 m-0 pl-2">
                    {
                        flag_open_modal_edit === true ? 'Editar Trabalhador' :
                            flag_open_modal_ver_mais === true ? 'Detalhes do Trabalhador' :
                                'Adicionar Trabalhador'
                    }
                </h2>
                <button
                    type="button"
                    onClick={() => {
                        if (flag_editado) {
                            set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                        } else {
                            set_flag_open_modal(false)
                            set_flag_open_modal_edit(false)
                            set_flag_open_modal_ver_mais(false)
                        }
                    }}
                    className="p-1 text-gray-400 hover:text-gray-600 transition-colors border-0 outline-none cursor-pointer !bg-transparent hover:!bg-transparent"
                >
                    <CloseIcon sx={{ fontSize: 24 }} />
                </button>
            </div>

            {
                isLoading === true ?
                    loader() :
                    <>
                        <div className="flex flex-col items-center w-full flex-1 overflow-auto">
                            <div className="flex items-center w-full py-4 px-4">
                                <Stepper activeStep={passo_atual} alternativeLabel className="w-full">
                                    {steps.map((label) => (
                                        <Step key={label} sx={{
                                            '& .MuiStepLabel-root .Mui-completed': {
                                                color: cores.cor3, // circle color (COMPLETED)
                                            },
                                            '& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel':
                                            {
                                                color: cores.cor2, // Just text label (COMPLETED)
                                            },
                                            '& .MuiStepLabel-root .Mui-active': {
                                                color: cores.cor1, // circle color (ACTIVE)
                                            },
                                            '& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel':
                                            {
                                                color: cores.cor1, // Just text label (ACTIVE)
                                            },
                                            '& .MuiStepLabel-root .Mui-active .MuiStepIcon-text': {
                                                fill: 'white', // circle's number (ACTIVE)
                                            },
                                        }}>
                                            <StepLabel>{label}</StepLabel>
                                        </Step>
                                    ))}
                                </Stepper>

                            </div>

                            {

                                passo_atual === 0 ? <div className="flex flex-col w-full p-6">


                                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 w-full">
                                        {
                                            lista_de_trabalhadores_aux.length === 0 ? (
                                                <div className="text-gray-400 py-4">Trabalhadores Não Encontrados</div>
                                            ) : (
                                                lista_de_trabalhadores_aux.map((el, key) => {
                                                    const isSelected = obj_trabalhador_selecionado?.id_trabalhador === el.id_trabalhador;
                                                    const isHovered = hover.flag && hover.id_trabalhador === el.id_trabalhador;
                                                    return (
                                                        <div
                                                            key={key}
                                                            className={`
                  flex flex-col items-center justify-center min-w-0 p-4 rounded-xl cursor-pointer
                  transition-all duration-200
                  ${isSelected ? 'ring-2 ring-[#c94f1e] bg-[#f2d1c2]/30' : 'bg-gray-50/80'}
                  ${isHovered ? 'shadow-md' : 'shadow-sm'}
                `}
                                                            onMouseEnter={() => setHover({ flag: true, id_trabalhador: el.id_trabalhador ?? 0 })}
                                                            onMouseLeave={() => setHover({ flag: false, id_trabalhador: el.id_trabalhador ?? 0 })}
                                                            onClick={() => {
                                                                if (obj_trabalhador_selecionado?.id_trabalhador === el.id_trabalhador) {
                                                                    set_obj_trabalhador_selecionado(undefined);

                                                                } else {

                                                                    set_obj_trabalhador_selecionado(el);
                                                                }

                                                            }}
                                                        >
                                                            <div className="text-sm font-medium text-gray-800 text-center">
                                                                {el.nome}
                                                            </div>
                                                            <div
                                                                className={`mt-2 w-full h-1 rounded-full ${isSelected ? 'bg-[#c94f1e]' : 'bg-gray-200'}`}
                                                            />
                                                        </div>
                                                    );
                                                })
                                            )
                                        }
                                    </div>

                                    <div className="flex justify-end w-full pt-4">

                                        <button
                                            type="button"
                                            onClick={() => {

                                                if (obj_trabalhador_selecionado?.id_trabalhador === undefined) {
                                                    setMessage("Selecione um caderno para avançar")
                                                    setOpenSnackError(true);
                                                } else {
                                                    set_passo_atual(1);

                                                }

                                            }}
                                            className="px-5 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                        >
                                            Seguinte
                                        </button>
                                    </div>
                                </div>
                                    :
                                    passo_atual === 1 ?
                                        <>
                                            <div className="flex flex-col gap-6 w-full p-5 rounded-xl bg-gray-50/80">
                                                {/* row 1: Designacao, Tipo, Localizacao, Stock minimo */}
                                                <div className="flex flex-wrap gap-6 w-full">
                                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                                        {
                                                            flag_open_modal_ver_mais === true ? <>
                                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Horas</div>
                                                                <div className="text-base font-medium text-gray-800">{obj_new?.horas || '-'}</div>
                                                            </>
                                                                :
                                                                flag_open_modal_edit === true ?
                                                                    <div className="md:col-span-2 w-full">
                                                                        <CustomTextField
                                                                            variant="outlined"
                                                                            label='Horas'
                                                                            name="horas"
                                                                            error={campo_obrigatorio_horas}
                                                                            helperText={campo_obrigatorio_horas ? 'Campo numérico' : ''}
                                                                            value={obj_new?.horas === undefined ? '' : obj_new?.horas}
                                                                            onChange={onInputChange}
                                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                                        />
                                                                    </div> : <></>
                                                        }
                                                    </div>
                                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                                        {
                                                            flag_open_modal_ver_mais === true ? <>

                                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Custo Hora</div>
                                                                <div className="text-base font-medium text-gray-800">{obj_new?.custo_hora || '-'}</div>
                                                            </>
                                                                :
                                                                flag_open_modal_edit === true ?
                                                                    <div className="md:col-span-2 w-full">
                                                                        <CustomTextField
                                                                            variant="outlined"
                                                                            label='Custo Hora'
                                                                            name="custo_hora"
                                                                            value={obj_new?.custo_hora === undefined ? '' : obj_new?.custo_hora}
                                                                            onChange={onInputChange}
                                                                            error={campo_obrigatorio_custo_hora}
                                                                            helperText={campo_obrigatorio_custo_hora ? 'Campo numérico' : ''}
                                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                                        />
                                                                    </div> : <></>
                                                        }
                                                    </div>
                                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                                        {
                                                            flag_open_modal_ver_mais === true ? <>

                                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Data</div>
                                                                <div className="text-base font-medium text-gray-800">{obj_new?.data || '-'}</div>
                                                            </>
                                                                :
                                                                flag_open_modal_edit === true ?
                                                                    <div className="md:col-span-2 w-full">

                                                                        <TextField
                                                                            label="Data"
                                                                            type="date"
                                                                            name="data"
                                                                            value={obj_new?.data === undefined ? '' : obj_new?.data}
                                                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                                                set_flag_editado(true)

                                                                                set_obj_new((old: any) => ({
                                                                                    ...old,
                                                                                    ['data']: event.target.value,
                                                                                }));

                                                                            }}
                                                                            InputLabelProps={{
                                                                                shrink: true,
                                                                            }}
                                                                            fullWidth
                                                                            margin="normal"
                                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                                        />

                                                                    </div> : <></>
                                                        }
                                                    </div>
                                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                                        {
                                                            flag_open_modal_ver_mais === true ? <>

                                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Notas</div>
                                                                <div className="text-base font-medium text-gray-800">{obj_new?.notas || '-'}</div>
                                                            </>
                                                                :
                                                                flag_open_modal_edit === true ?
                                                                    <div className="md:col-span-2 w-full">
                                                                        <CustomTextField
                                                                            variant="outlined"
                                                                            label='Notas'
                                                                            name="notas"
                                                                            value={obj_new?.notas === undefined ? '' : obj_new?.notas}
                                                                            onChange={onInputChange}
                                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                                        />
                                                                    </div> : <></>
                                                        }
                                                    </div>
                                                </div>


                                            </div>
                                            {flag_open_modal_ver_mais === true ? <></> :

                                                <div className="p-5 flex justify-between w-full pt-4">

                                                    <button
                                                        type="button"
                                                        onClick={() => set_passo_atual(0)}
                                                        className="px-5 py-2.5 mt-4 rounded-xl font-medium text-sm text-gray-600 bg-gray-100 hover:bg-gray-200 transition-colors border-0 outline-none cursor-pointer"
                                                    >
                                                        Voltar
                                                    </button>
                                                    <button
                                                        type="button"
                                                        onClick={() => {


                                                            if (campo_obrigatorio_horas === true || campo_obrigatorio_custo_hora === true) {
                                                                setOpenSnackError(true);
                                                                setMessage('Preencha os campos corretamente')

                                                            } else {

                                                                if (flag_open_modal_edit === true && flag_open_modal_add === false) {
                                                                    handler_edit()
                                                                } else if (flag_open_modal_add === true) {
                                                                    handler_add()
                                                                }
                                                            }
                                                        }}
                                                        className="px-5 py-2.5 mt-4 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                                    >
                                                        Guardar Informação
                                                    </button>
                                                </div>
                                            }
                                        </>
                                        : <></>
                            }


                        </div>


                    </>
            }
            <ConfirmDialog
                open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
                onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
                onConfirm={() => handleCloseDialog()}
                message={mensagem_tem_a_certeza_de_apagar_alteracoes}
            />
        </div>



    </Modal >)

}
